import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import PlusIcon from '@mui/icons-material/Add';

import AAutofill from './AAutofill';

/*
 * Call something like this:
 *
  <UnaffiliatedContactsBox
    unaffiliatedContactOptions={this.searchableContactData.filter(...)}
    chosenOption={object}
    onContactChange={(personId) => this.selectContact(null, 0, personId)}
    onCreateNewContact={(referrerType, firmId) => this.forceShowingOfNewContactModal(referrerType, firmId)}
  />
 */

const createLocalStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
  },
  containedAutocompleteDiv: {
    display: 'inline-block',
    width: '100%',
  },
  visiblePlus: {
    display: 'inherit',
    cursor: 'pointer',
    paddingLeft: '4px',
    transform: 'translate(0, 14px) scale(0.8)',
  },
}));

const getIdOfOptionWithName = (name, unaffiliatedContactOptions) => {
  const matchingOption = unaffiliatedContactOptions.find((option) => option.name === name);
  return matchingOption ? matchingOption.personId : 0;
};

const UnaffiliatedContactBox = ({ unaffiliatedContactOptions, chosenOption, onContactChange, onCreateNewContact }) => {
  const classes = createLocalStyles();

  const currentOptionName = chosenOption ? chosenOption.name : null;
  const allOptionNames = unaffiliatedContactOptions.map((opt) => opt.name);

  return (
    <div className={classes.root}>
      <div className={classes.containedAutocompleteDiv}>
        <AAutofill
          label="Contact"
          options={allOptionNames}
          value={currentOptionName}
          onChange={(newlyChosenName) => {
            const contactId = getIdOfOptionWithName(newlyChosenName, unaffiliatedContactOptions);
            onContactChange(contactId);
          }}
        />
      </div>
      <div className={classes.visiblePlus} onClick={() => onCreateNewContact(null, 0)}>
        <PlusIcon />
      </div>
    </div>
  );
};

export default UnaffiliatedContactBox;
